import React, { useContext, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import SideMenuContext from "./../../../common/context/sideMenuContext";
import {
  getDynamicFieldsFromMenu,
  loadImage,
} from "./../../../common/services/uiService";

import "./../../../common/styles/sidebar.css";

//import "./../../styles/home.css";

//import { render } from "@testing-library/react";
//import { isMobile } from "react-device-detect";

const SideBarMapi = (props) => {
  const sideMenuContext = useContext(SideMenuContext);
  const menues = sideMenuContext.menues;
  const location = useLocation();

  const [menuOpen, setMenuOpen] = useState(false);

  const elements = menues;
  const [orderedElements, setOrderedElements] = useState([]);

  useEffect(() => {
    // Step 1: Separate parents and children
    const parents = elements?.filter((el) => el.parentItemId === 0);
    const children = elements?.filter((el) => el.parentItemId !== 0);

    // Step 2: Sort parents by their index
    parents.sort((a, b) => a.index_ - b.index_);

    // Step 3: Create a dictionary of children sorted by their parent and index
    const childrenByParent = parents.reduce((acc, parent) => {
      acc[parent.itemId] = children
        .filter((child) => child.parentItemId === parent.itemId)
        .sort((a, b) => a.index_ - b.index_);
      return acc;
    }, {});

    const ordered = [];
    parents.forEach((parent) => {
      ordered.push(parent);
      if (childrenByParent[parent.itemId]) {
        ordered.push(...childrenByParent[parent.itemId]);
      }
    });
    // Update the state with the ordered elements
    setOrderedElements(ordered);
  }, [elements]);

  useEffect(() => {
    setTimeout(() => {
      if (
        "/home/intake" === location.pathname ||
        "/home/projects" === location.pathname ||
        /^\/home\/project-details\/\d+$/.test(location.pathname)
      ) {
        if (localStorage.getItem("routeActive") === "listproject-route") {
          const listItem = document.getElementById(
            "ChildSideMenuLink ChildMenuActive nav-item active 20"
          );
          const spanTitle = document.getElementById("20");
          if (listItem) {
            listItem.classList.add("ChildMenuActive", "active", "active-bold");
          }
          if (spanTitle) {
            spanTitle.classList.add("active");
          }

          // remove active
          const listItem1 = document.getElementById(
            "ChildSideMenuLink ChildMenuActive nav-item active 19"
          );
          const spanTitle1 = document.getElementById("19");
          if (listItem1) {
            listItem1.classList.remove(
              "ChildMenuActive",
              "active",
              "active-bold"
            );
          }
          if (spanTitle1) {
            spanTitle1.classList.remove("active");
          }
        } else if (
          localStorage.getItem("routeActive") === "singleproject-route"
        ) {
          const listItem = document.getElementById(
            "ChildSideMenuLink ChildMenuActive nav-item active 19"
          );
          const spanTitle = document.getElementById("19");
          if (listItem) {
            listItem.classList.add("ChildMenuActive", "active", "active-bold");
          }
          if (spanTitle) {
            spanTitle.classList.add("active");
          }

          // remove active
          const listItem3 = document.getElementById(
            "ChildSideMenuLink ChildMenuActive nav-item active 20"
          );
          const spanTitle3 = document.getElementById("20");
          if (listItem3) {
            listItem3.classList.remove(
              "ChildMenuActive",
              "active",
              "active-bold"
            );
          }
          if (spanTitle3) {
            spanTitle3.classList.remove("active");
          }
        } else if (!localStorage.getItem("routeActive")) {
          const listItem3 = document.getElementById(
            "ChildSideMenuLink ChildMenuActive nav-item active 20"
          );
          const spanTitle3 = document.getElementById("20");
          if (listItem3) {
            listItem3.classList.remove(
              "ChildMenuActive",
              "active",
              "active-bold"
            );
          }
          if (spanTitle3) {
            spanTitle3.classList.remove("active");
          }
        }
      } else if ("/home/create-project" === location.pathname) {
        const listItem = document.getElementById(
          "ChildSideMenuLink ChildMenuActive nav-item active 20"
        );
        const spanTitle = document.getElementById("20");
        if (listItem) {
          listItem.classList.remove("ChildMenuActive", "active", "active-bold");
        }
        if (spanTitle) {
          spanTitle.classList.remove("active");
        }
      } else {
        if (localStorage.getItem("routeActive") === "singleproject-route") {
          const listItem = document.getElementById(
            "ChildSideMenuLink ChildMenuActive nav-item active 20"
          );
          const spanTitle = document.getElementById("20");
          if (listItem) {
            listItem.classList.remove(
              "ChildMenuActive",
              "active",
              "active-bold"
            );
          }
          if (spanTitle) {
            spanTitle.classList.remove("active");
          }
        }
        if (localStorage.getItem("routeActive") === "listproject-route") {
          const listItem1 = document.getElementById(
            "ChildSideMenuLink ChildMenuActive nav-item active 19"
          );
          const spanTitle1 = document.getElementById("19");
          if (listItem1) {
            listItem1.classList.remove(
              "ChildMenuActive",
              "active",
              "active-bold"
            );
          }
          if (spanTitle1) {
            spanTitle1.classList.remove("active");
          }
        }
      }

      if ("/home" === location.pathname) {
        const listItem = document.getElementById(
          "ChildSideMenuLink ChildMenuActive nav-item active 20"
        );
        const spanTitle = document.getElementById("20");
        if (listItem) {
          listItem.classList.remove("ChildMenuActive", "active", "active-bold");
        }
        if (spanTitle) {
          spanTitle.classList.remove("active");
        }

        //
        const listItem1 = document.getElementById(
          "ChildSideMenuLink ChildMenuActive nav-item active 19"
        );
        const spanTitle1 = document.getElementById("19");
        if (listItem1) {
          listItem1.classList.remove(
            "ChildMenuActive",
            "active",
            "active-bold"
          );
        }
        if (spanTitle1) {
          spanTitle1.classList.remove("active");
        }
      }
    }, 500);
  }, [location.pathname]);

  function handleClickAnimation(event) {
    sessionStorage.setItem(
      "CurrentMouseLocation",
      event.pageX + "," + event.pageY
    );

    var sideMenuDiv = document.getElementById("SideMenu");
    if (sideMenuDiv) {
      // !== undefined)
      sideMenuDiv.style.animationName = "pageAnimationSideBarMobile";
    }
  }

  function onMouseOver(event) {
    if (event.target.tagName === "LI") {
      var selectAttr = event.target.getAttribute("select");
      if (selectAttr === "false") {
        event.target.className = event.target.id;
      }
    } else {
      var selectAttr =
        event.target.parentElement.parentElement.getAttribute("select");
      if (selectAttr === "false") {
        event.target.parentElement.parentElement.className =
          event.target.parentElement.parentElement.id;
      }
    }
  }

  function onMouseOut(event) {
    if (event.target.tagName === "LI") {
      var selectAttr = event.target.getAttribute("select");
      if (selectAttr === "false") {
        event.target.className = "SideMenuLink";
      }
    } else {
      var selectAttr =
        event.target.parentElement.parentElement.getAttribute("select");
      if (selectAttr === "false") {
        event.target.parentElement.parentElement.className = "SideMenuLink";
      }
    }
  }

  function closeHelp() {
    var sideMenuDiv = document.getElementById("SideMenu");

    if (sideMenuDiv !== undefined) {
      sideMenuDiv.style.animationName = "pageAnimationSideBarMobileReverse";
      sideMenuDiv.style.animationDuration = "0.75s";
    }
  }

  const groupedData = elements?.reduce((acc, item) => {
    const { formId } = item;
    if (!acc[formId]) {
      acc[formId] = [];
    }
    acc[formId].push(item);
    return acc;
  }, {});

  return (
    <React.Fragment>
      <nav id="leftMenu" className="navbar    navbar-expand-lg navbar-light">
        <div className="navbar-collapse" id="mainMenuNav">
          <ul
            id="LeftSideMenu"
            className={
              props.isDisabled
                ? "navbar-nav-vertical mr-auto disabled"
                : "navbar-nav-vertical mr-auto"
            }
            aria-expanded="false"
          >
            {orderedElements.map((mItem, index) => {
              if (mItem.parentItemId === 0) {
                mItem.beforeSpace = "1";
                mItem.beforeSpaceClass = "BeforeHomeSpace";
                mItem.regClassName = "ParentMenuLink nav-item";
                mItem.activeClassName =
                  "ParentMenuLink ParentMenuActiveSettings nav-item active";
                mItem.regTitleClassName = "ParentMenuTitle";
                mItem.activeTitleClassName =
                  "ParentMenuTitle ParentMenuTitleActive";
                if (mItem.formId === 2) {
                  mItem.beforeSpace = "1";
                  mItem.beforeSpaceClass = "BeforeHomeSpace";
                  mItem.regClassName = "ParentMenuLink nav-item";
                  mItem.activeClassName =
                    "ParentMenuLink ParentMenuActiveSettings nav-item active";
                  mItem.regTitleClassName = "ParentMenuTitle";
                  mItem.activeTitleClassName =
                    "ParentMenuTitle ParentMenuTitleActive";
                } else {
                  mItem.beforeSpace = "1";
                  mItem.beforeSpaceClass = "BeforeHomeSpace";
                  mItem.regClassName = "ParentMenuLink nav-item";
                  mItem.activeClassName =
                    "ParentMenuLink ParentMenuActive nav-item active";
                  mItem.regTitleClassName = "ParentMenuTitle";
                  mItem.activeTitleClassName =
                    "ParentMenuTitle ParentMenuTitleActive";
                }
              } else {
                // Set default values for cases where parentitemid is not 1
                mItem.beforeSpace = "";
                mItem.beforeSpaceClass = "";
                mItem.regClassName = "ChildSideMenuLink nav-item ";
                mItem.activeClassName =
                  "ChildSideMenuLink ChildMenuActive nav-item active";
                mItem.regTitleClassName = "ChildMenuTitle";
                mItem.activeTitleClassName = "ChildMenuTitle active";
                mItem.activeImg = "";
                mItem.nonActiveImg = "";
              }

              return (
                <div key={mItem.itemId}>
                  {mItem.beforeSpace && (
                    <div className={mItem.beforeSpaceClass}>
                      {mItem.beforeTitle && (
                        <p className={mItem.beforeTitleClass}>
                          {mItem.beforeTitle}
                        </p>
                      )}
                    </div>
                  )}
                  <Link
                    to={{ pathname: mItem.to, state: "flushDeal" }}
                    key={index}
                    id={index + "" + mItem.itemId}
                    onClick={() => {
                      if (mItem.to != "") {
                        sideMenuContext?.setSelectedMenu(mItem);
                        props.handleClick(mItem);
                        Number(mItem?.["itemId"]) <= 2 &&
                          getDynamicFieldsFromMenu(
                            props.generalEndPoint,
                            2 || mItem?.["itemId"]
                          )
                            .then((result) => {
                              sideMenuContext.setActiveTabData(result);
                            })
                            .catch((error) => {
                              console.log(error);
                            });
                      }
                    }}
                  >
                    <li
                      // id={mItem.activeClassName}
                      id={mItem.activeClassName + " " + mItem.itemId}
                      select={
                        props.currentLocation === mItem.to ? "true" : "false"
                      }
                      className={
                        props.currentLocation === mItem.to
                          ? mItem.activeClassName +
                            // [1,4]
                            //   groupedData?.[`${mItem?.["formId"]}`]?.[0]?.[
                            //   "itemId"
                            // ] == mItem?.["itemId"]
                            (mItem?.["parentItemId"] === 0 ? "" : " mr-cls") +
                            // ([1, 3].includes(mItem.itemId) ? "" : " mr-cls") +
                            (mItem.itemId ===
                            sideMenuContext?.isSelectedMenu?.["itemId"]
                              ? " active-bold"
                              : "")
                          : mItem.regClassName +
                            // [1,4]
                            //   groupedData?.[`${mItem?.["formId"]}`]?.[0]?.[
                            //   "itemId"
                            // ] == mItem?.["itemId"]
                            (mItem?.["parentItemId"] === 0 ? "" : " mr-cls") +
                            // ([1, 3].includes(mItem.itemId) ? "" : " mr-cls") +
                            (mItem.itemId ===
                            sideMenuContext?.isSelectedMenu?.["itemId"]
                              ? " active-bold"
                              : "")
                      }
                      key={mItem.id}
                      onClick={handleClickAnimation}
                    >
                      <span>
                        <span
                          id={mItem.itemId}
                          className={
                            props.currentLocation === mItem.to
                              ? mItem.activeTitleClassName
                              : mItem.regTitleClassName
                          }
                        >
                          {mItem.title}
                        </span>
                      </span>

                      <span className="leftMenuImg">
                        {props.currentLocation === mItem.to ? (
                          mItem.activeImg !== "" ? (
                            <img
                              src={loadImage(mItem.activeImg)}
                              alt={mItem.title}
                            />
                          ) : (
                            <div></div>
                          )
                        ) : mItem.nonActiveImg !== "" ? (
                          <img
                            src={loadImage(mItem.nonActiveImg)}
                            alt={mItem.title}
                          />
                        ) : (
                          <div></div>
                        )}
                      </span>
                    </li>
                  </Link>
                </div>
              );
            })}
          </ul>
        </div>
      </nav>
    </React.Fragment>
  );
  {
    /*
    <div>
      <h1>Ordered Elements</h1>
      <ul>
        {orderedElements.map(el => (
          <li key={el.itemId}>
            {el.parentItemId === 0 ? `Parent: ${el.itemId}` : `Child: ${el.itemId} (Parent: ${el.parentItemId})`} - Index: {el.index_}
          </li>
        ))}
      </ul>
        </div>*/
  }

  {
    /*
----------------------------------------------------------------------------------------------
Version 1
----------------------------------------------------------------------------------------------
  // Function to group and sort menu items by parentItemId and index_
  const organizeMenuItems = (menuItems) => {
    const menuMap = {};

    // Group by parentItemId and sort by index_
    menuItems.forEach(item => {
      if (!menuMap[item.parentItemId]) {
        menuMap[item.parentItemId] = [];
      }
      menuMap[item.parentItemId].push(item);
    });

    Object.keys(menuMap).forEach(parentItemId => {
      menuMap[parentItemId].sort((a, b) => a.index_ - b.index_);
    });

    return menuMap;
  };


  // Recursive function to render menu items
const renderMenuItems = (menuMap, parentItemId = null) => {

  return (
    <ul>
      {menuMap[parentItemId].map(mItem => {
        const isActive = props.currentLocation === mItem.to;
        const mItemClassName = isActive ? mItem.activeClassName : mItem.regClassName;
        const mTitleClassName = isActive ? mItem.activeTitleClassName : mItem.regTitleClassName;

        return (
          <li key={mItem.id} className={mItemClassName}>
            <Link to={{ pathname: mItem.to, state: 'flushDeal' }} onClick={() => props.handleClick(mItem)}>
              <span className={mTitleClassName}>{mItem.title}</span>
              <span className="sideMenuImg">
                <img src={loadImage(isActive ? mItem.activeImg : mItem.nonActiveImg)} alt={mItem.title} />
              </span>
            </Link>
            {renderMenuItems(menuMap, mItem.id)}
          </li>
        );
      })}
    </ul>
  );
};


  menues.forEach(mItem => {
    if (mItem.parentitemid === 0) {
      mItem.beforeSpace = "1";
      mItem.beforeSpaceClass = "BeforeHomeSpace";
      mItem.regClassName = "SideMenuLink nav-item";
      mItem.activeClassName = "SideMenuLink HomeMenuActive nav-item active";
      mItem.regTitleClassName = "sideMenuTitle";
      mItem.activeTitleClassName = "sideMenuTitle HomeMenuTitleActive";
    } else {
      mItem.beforeSpace = "";
      mItem.beforeSpaceClass = "";
      mItem.regClassName = "SideMenuLink nav-item";
      mItem.activeClassName = "SideMenuLink nav-item active";
      mItem.regTitleClassName = "sideMenuTitle";
      mItem.activeTitleClassName = "sideMenuTitle active";
    }
  });

  // Organize and sort menu items
  const menuMap = organizeMenuItems(menues);
  return <div>{renderMenuItems(menuMap, 0)}</div>;
*/
  }

  {
    /*
----------------------------------------------------------------------------------------------
Original
----------------------------------------------------------------------------------------------

  return (
    <React.Fragment>
      <nav id="leftMenu" className="navbar    navbar-expand-lg navbar-light">
      <div className="navbar-collapse collapse" id="mainMenuNav">
      
      
      <ul id="SideMenu" className="navbar-nav-vertical mr-auto"  aria-expanded="false">
        {menues.map((mItem) => {
          if (mItem.parentItemId===1)
          {
            mItem.beforeSpace= "1";
            mItem.beforeSpaceClass= "BeforeHomeSpace";
            mItem.regClassName= "SideMenuLink  nav-item";
            mItem.activeClassName= "SideMenuLink HomeMenuActive nav-item active";
            mItem.regTitleClassName= "sideMenuTitle";
            mItem.activeTitleClassName= "sideMenuTitle HomeMenuTitleActive";
          } else {
            // Set default values for cases where parentitemid is not 1
            mItem.beforeSpace = "";
            mItem.beforeSpaceClass = "";
            mItem.regClassName = "SideMenuLink nav-item";
            mItem.activeClassName = "SideMenuLink nav-item active";
            mItem.regTitleClassName = "sideMenuTitle";
            mItem.activeTitleClassName = "sideMenuTitle active";
          }
        
        return(
          <div key={mItem.id}    >
            {mItem.beforeSpace && (
              <div className={mItem.beforeSpaceClass}>
                {mItem.beforeTitle && (
                  <p className={mItem.beforeTitleClass}>{mItem.beforeTitle}</p>
                )}
              </div>
            )}
             <Link to={{pathname: mItem.to ,state:'flushDeal'}} key={mItem.id} onClick={()=> { props.handleClick(mItem);}}  >
                <li  id={mItem.activeClassName} select={props.currentLocation === mItem.to ? 'true' : 'false'}
                  className={
                    props.currentLocation === mItem.to
                      ? mItem.activeClassName
                      : mItem.regClassName
                  }
                  key={mItem.id} onClick={handleClickAnimation} onMouseOver={onMouseOver} onMouseOut={onMouseOut}
               >
              
                  <span>
                    <span  
                      className={
                        props.currentLocation === mItem.to
                          ? mItem.activeTitleClassName
                          : mItem.regTitleClassName
                      }
                    >
                    {mItem.title}
                    </span>
                  </span>

                  <span className="sideMenuImg"    >
                    {props.currentLocation === mItem.to ? (
                      <img src={loadImage(mItem.activeImg)} alt={mItem.title} />
                    ) : (
                      <img
                        src={loadImage(mItem.nonActiveImg)}
                        alt={mItem.title}
                      />
                    )}
                  </span>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
                </li>
                </Link>      
          </div>
        )})}
                    </ul>
      
      </div>
     
      </nav>
      
    </React.Fragment>
                    );*/
  }
};

export default SideBarMapi;
